import { identify, track } from '@/lib/analytics'
import type { AuthAnalyticsEvent } from '@/state/auth-analytics'

const VALID_METHODS = new Set(['email', 'passkey', 'google'])
const VALID_KINDS = new Set(['login', 'signup'])

/** identify → track, awaited so the event is always attributed to the user. */
export async function flushAuthAnalyticsEvent(event: AuthAnalyticsEvent): Promise<void> {
  await identify(event.userId)
  await track(event.kind === 'signup' ? 'Sign up' : 'Log in', { method: event.method })
}

/** Parses the one-shot cookie planted by the Google redirect callback. */
export function parseAuthAnalyticsCookie(raw: string | undefined): AuthAnalyticsEvent | null {
  if (!raw) return null
  try {
    const parsed = JSON.parse(raw) as Partial<AuthAnalyticsEvent>
    if (
      typeof parsed.userId !== 'string' ||
      !parsed.userId ||
      !VALID_METHODS.has(parsed.method ?? '') ||
      !VALID_KINDS.has(parsed.kind ?? '')
    ) {
      return null
    }
    return parsed as AuthAnalyticsEvent
  } catch {
    return null
  }
}
